import React from 'react'
import { useForm } from '@inertiajs/react'
import { Card, CardContent } from '@/components/ui/card'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { Textarea } from '@/components/ui/textarea'
import { Send, Loader2 } from 'lucide-react'

export default function RequestForm() {
  const form = useForm({
    integration_request: {
      name: '',
      url: '',
      purpose: '',
    },
  })

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    form.post('/dashboard/integrations/requests')
  }

  const data = form.data.integration_request
  const setField = (field: keyof typeof data, value: string) => {
    form.setData('integration_request', { ...data, [field]: value })
  }

  return (
    <div className="max-w-lg mx-auto">
      <Card>
        <CardContent className="p-6">
          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="space-y-2">
              <Label htmlFor="name">Nome da integração</Label>
              <Input
                id="name"
                placeholder="Ex: Shopify, HubSpot, Pipedrive..."
                value={data.name}
                onChange={(e) => setField('name', e.target.value)}
                required
              />
              {form.errors['integration_request.name'] && (
                <p className="text-sm text-destructive">{form.errors['integration_request.name']}</p>
              )}
            </div>

            <div className="space-y-2">
              <Label htmlFor="url">URL da ferramenta</Label>
              <Input
                id="url"
                type="url"
                placeholder="https://..."
                value={data.url}
                onChange={(e) => setField('url', e.target.value)}
                required
              />
              {form.errors['integration_request.url'] && (
                <p className="text-sm text-destructive">{form.errors['integration_request.url']}</p>
              )}
            </div>

            <div className="space-y-2">
              <Label htmlFor="purpose">Para que você usaria essa integração?</Label>
              <Textarea
                id="purpose"
                placeholder="Descreva brevemente o que você espera que a integração faça..."
                value={data.purpose}
                onChange={(e) => setField('purpose', e.target.value)}
                required
              />
              {form.errors['integration_request.purpose'] && (
                <p className="text-sm text-destructive">{form.errors['integration_request.purpose']}</p>
              )}
            </div>

            <Button type="submit" className="w-full" disabled={form.processing}>
              {form.processing ? (
                <><Loader2 className="h-4 w-4 animate-spin" /> Enviando...</>
              ) : (
                <><Send className="h-4 w-4" /> Enviar solicitação</>
              )}
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  )
}
